import { useContext } from "react";
import { ModelingToolsContext } from "./modeling-tools-context.ts";

const useModelingToolsContext = () => {
    const context = useContext(ModelingToolsContext);
    if (!context) {
        throw new Error('useModelingToolsContext must be used within a ModelingToolsContextProvider');
    }

    return context;
};

export default useModelingToolsContext;